import noodleApiClient from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

type Input = { creatorId: string };
type Output = string[];

const PATH_TEMPLATE = '/pacer-emails/creator/{creatorId}/get-pacer-notice-types';

const getUniqueNoticeTypesFromPacer = async ({ creatorId }: Input): Promise<Output> => {
  const path = buildPath(PATH_TEMPLATE, { creatorId });
  const response = await noodleApiClient.get(path);
  return response.data;
};

export default getUniqueNoticeTypesFromPacer;
